import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import axios from 'axios';
import { getvmListAPI,getvmDetailsAPI ,getCityDataFromAPI,PostcohortsbasicDataFromPartnerAPI , UpdateVMDataFromPartnerAPI , deleteVmApi} from '../HandleAPICalls/actions';
import {
  setLoading,
  saveData,
  saveVMListData,
  saveVMDetailsData,
  setActivePage,
  setDropdownLoading,
  setCityOptions,
  setCitySelectedOptions
} from './actions';
import parseResponseToOptions, {
  parseVMTypeOptions,
  parseStateAndCityOptions,
  parseCohortOptions,
  parsePaymentsOptions,
  parseWarehouseOptions,
  parseVmHdTypeOptions,
  parseSlotsOptions,
  parseOperationalOptions,
  parseVmLoctonTypeOptions,

} from "../../utils/parseResponseToOptions";
import {
  getDataFromAPI,
  getseedDataFromAPI,
  CreatevmAPI,
  UploadImgAPI,


} from "../HandleAPICalls/actions";
import VendingMachine from './component';

const cart_Limt_array=[1,2,3,4,5,6,7,8,9,10]

function parseCartLimitOptions(options) {
  if (!options && options.length) {
    return { key: 0, text: 'None', value: 0 };
  }
  const parsed = options.map(el => ({
    key: el,
    text: el,
    value: el
  }));
  return [...parsed];
}




class VendingMachineContainer extends Component {
  constructor(props) {
    
    super(props);
    this.fetchNextUsers = this.fetchNextUsers.bind(this);
    // this.OnClickVMSideDetailsPage=this.OnClickVMSideDetailsPage.bind(this) 
    this.state = {
      searchName: '',
      searchId:'',
      vmName: null,
      vmName_capacity:null,
      vmSerialNo: null,
      vmName_mv: null,
      vmName_sv: null,
      warehouseId:null,
      vmName_capacity:null,
      vmStreet: null,
      vmCity: null,
      cityList: [],
      cityLoading: true,
      vmTypeOptions:[],
      vmTypeLoading:null,
      loading:null,
      stateList:[],
      stateLoading:null,
      stateLoading:null,
      isConsumerAppEnabled:null,
      isHealthEnabled:null,
        loading:null,
        cohorts: [],
        payments:[],
        hardware_types: [],
        machine_types:[],
        warehouses:[],
        vmTypeId:null,
        hardware_type_id:null,
        lat:null,
        lng:null,
        vmCity:'',
        vmState:null,
        vmCity:null,
        stateList: [],
        vmStreet: null,
        sharePercentage:null,
        oparationalstatusTypes:[],
        operational_status_id:null,
        added_cohort_id:[],
        remove_cohort_id:[],
        added_payments_id:[],
        remove_payments_id:[],
        remove_slots_id:[],
      searchCohortQuery:'',
      AddCohortsOptions: [],
      RemoveCohortsOptions:[],
      RemovePaymentsOptions:[],
      AddPaymentsOptions:[],
      allcohorts:[],
      cohortvalue:[],
      removed_cohort_id:[],
      allpayments:[],
      allSlots:[],
      filterType:'NAME',
      image:null,
      count: 99,
      start: 0,
      users:[],
      allMachine:[],
      morescroll:true,
      modal:false,
      Decomissionmodel:false,
      image_path:null,
      searchList:null,
      location_types:[],
      location_type_id:null,
      cartLimit:null,
      cart_Limt:[],
      corporates:[],
      corporateId:null
      
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.allMachine.length !== this.state.allMachine.length) {
      this.setState({
        allMachine: this.state.allMachine
      });
    }
  }


  onChangeOfLocationTypeId=(e,data)=>{
    this.setState({location_type_id:data.value});
    console.log("onChangeOfLocationTypeId -->",this.state.location_type_id)

  }

  fetchAllMachine() {
      const { count, start } = this.state;

      
     
      this.props.getvmListAPI(
        `/partner/api/v2/machine?pageSize=${count}&pageNumber=${start}`,
        'GET',
        undefined,
        response => {
          console.log("Get machine ");
         this.props.saveVMListData(response); 
         if(response){
          this.setState({allMachine:response})

         }
          
          //this.props.setLoading(false);
          
          console.log("allmachine--->f",response)
        },
        err => {
         // this.props.setLoading(false);
          //toastr.error('ERROR', err);
          //console.log(err);
        }
      ); 
      console.log("allmachine--->f",this.state.allMachine)
  
  }

fetchNextUsers() {
    const { count, start } = this.state;
    this.setState({ start: this.state.start + 1});
  const pageNumber =this.state.start+1
    console.log("start",this.state.start)

    this.props.getvmListAPI(
      `/partner/api/v2/machine?pageSize=${count}&pageNumber=${pageNumber}`,
      'GET',
      undefined,
      response => {
        console.log("Get machine ");
        if(response){
          this.setState({
          allMachine: this.state.allMachine.concat(response),
          
        })
       

         }
       
         console.log("false Running",response)
         if(!response){
          console.log("false Running",pageNumber)
          this.setState({
          morescroll:false
        })
        } 
        /* this.setState({allMachine:response}) */
        //this.props.setLoading(false);
      },
      err => {
       // this.props.setLoading(false);
        //toastr.error('ERROR', err);
        //console.log(err);
      }
    ); 
    console.log("allMachine",this.state.allMachine)
  
 /*  this.setState({
    allMachine: this.state.allMachine.concat(response.data.results)
  }); */
  }  
  componentDidMount() {

   
    // fetch all the permissions
    this.props.setLoading(true);
    this.props.setDropdownLoading(true);
    this.props.setActivePage(1);
    this.fetchAllMachine();
    this.props.getvmListAPI(
      `/partner/api/v2/machine`,
      'GET',
      undefined,
      response => {
        console.log("Get machine ");
       // this.props.saveVMListData(response);
       this.setState({
        allMachine:response
       })
        //this.props.setLoading(false);
      },
      err => {
       // this.props.setLoading(false);
        //toastr.error('ERROR', err);
        //console.log(err);
      }
    ); 



    this.props.getDataFromAPI(
      "/vendingmachines/location/states",
      "GET",
      undefined,
      (response) => {
        console.log(
          "user role response list",
          parseStateAndCityOptions(response.list)
        );
        this.setState({
          stateList: parseStateAndCityOptions(response.list),
          stateLoading: false,
          loading: false,
        });
      },
      (err) => {
        console.log(err);
        toastr.error("Failed", "Unable to fetch vending machine type list");
        this.setState({ loading: false, stateLoading: false });
      }
    );
  

     this.props.getDataFromAPI(
      `/vendingmachines/all`,
      'GET',
      undefined,
      response => {
        this.props.saveData(response);
        this.props.setLoading(false);
      },
      err => {
        this.props.setLoading(false);
        toastr.error('ERROR', err);
        console.log(err);
      }
    );

    this.props.getDataFromAPI(
      "/vendingmachines/vmtypes",
      "GET",
      undefined,
      (response) => {
        console.log("VMTYPES response", response);
        this.setState({
          vmTypeOptions: parseVMTypeOptions(response.list),
          //vmTypeLoading: false,
          //loading: false,
        });
      },
      (err) => {
        console.log(err);
        toastr.error("Failed", "Unable to fetch vending machine type list");
        this.setState({ loading: false, vmTypeLoading: false });
      }
    )
    this.props.getseedDataFromAPI(
      "/partner/api/v2/machine/seed",
      "GET",
      undefined,
      (response) => {
        console.log("SeedData", response);
        this.setState({
          allcohorts:response.cohorts,
          allpayments:response.payment_configs,
          allSlots:response.slots,
          cohorts: parseCohortOptions(response.cohorts),
          payments: parsePaymentsOptions(response.payment_configs),
          hardware_types: parseVmHdTypeOptions(response.hardware_types),
          machine_types: parseVmHdTypeOptions(response.machine_types),
          warehouses: parseWarehouseOptions(response.warehouses),
          location_types: parseVmLoctonTypeOptions(response.location_types),
          corporates: parseWarehouseOptions(response.corporates),
          oparationalstatusTypes:parseOperationalOptions(response.operational_status),
          cart_Limt:parseCartLimitOptions(cart_Limt_array)

          //vmTypeLoading: false,
          //loading: false
        });
        console.log(
          "parsePaymentsOptions(response.payment_configs)",
          parsePaymentsOptions(response.payment_configs)
        );
      }
    )

    



   

    
 } 


 openmodel=()=>{

  console.log("OPEN UPDATE VM MODAL",this.state.saveVMDetailsData)
this.setState({vmName:this.state.saveVMDetailsData.name})
//this.setState({vmTypeId:this.state.saveVMDetailsData.machine_type})
//this.setState({hardware_type_id:this.state.saveVMDetailsData.hardware_types.id});
this.setState({vmSerialNo:this.state.saveVMDetailsData.keys.serial_number})


  this.setState({
    modal:true

  })
}
openDecomissionmodel=()=>{
  console.log("OPEN UPDATE VM MODAL")
  this.setState({
    Decomissionmodel:true

  })
}


OnClickVMSideDetailsPage=(id)=>{



  console.log("Vmside",id)

  this.props.getvmDetailsAPI(
    `/partner/api/v2/machine/`,
    'GET',
    id,
    response => {
      console.log("Get machine----DETAILS---. ",response);
      this.setState({saveVMDetailsData:response,
        RemoveCohortsOptions:parseCohortOptions(response.cohorts),
        RemovePaymentsOptions:parseCohortOptions(response.payment_configs),
        RemoveSlotsOption:parseSlotsOptions(response.slots)
      });
      //this.props.setLoading(false);
      console.log("saveVMDetailsData----->",this.state.saveVMDetailsData.name)
      if(response){
        const a=this.state.allcohorts;
            const b= response.cohorts;
            console.log("DIFF--a>",a);
            console.log("DIFF-->",b);
                // A comparer used to determine if two entries are equal.
                const isSameUser = (a, b) => a.id === b.id && a.name== b.name;
                
                // Get items that only occur in the left array,
                // using the compareFunction to determine equality.
                const onlyInLeft = (left, right, compareFunction) => 
                  left.filter(leftValue =>
                    !right.some(rightValue => 
                      compareFunction(leftValue, rightValue)));
                
                const onlyInA = onlyInLeft(a, b, isSameUser);
                const onlyInB = onlyInLeft(b, a, isSameUser);
                
                const result = [...onlyInA, ...onlyInB];

                console.log("DIFFRENCE-----------",result)
                this.setState({AddCohortsOptions:parseCohortOptions(result)});
                console.log("AddCohortsOptions----------",this.state.AddCohortsOptions)
              
            }

            if(response){
              const a=this.state.allpayments;
                  const b= response.payment_configs;
                  console.log("DIFF--a>",a);
                  console.log("DIFF-->",b);
                      // A comparer used to determine if two entries are equal.
                      const isSameUser = (a, b) => a.id === b.id && a.name== b.name;
                      
                      // Get items that only occur in the left array,
                      // using the compareFunction to determine equality.
                      const onlyInLeft = (left, right, compareFunction) => 
                        left.filter(leftValue =>
                          !right.some(rightValue => 
                            compareFunction(leftValue, rightValue)));
                      
                      const onlyInA = onlyInLeft(a, b, isSameUser);
                      const onlyInB = onlyInLeft(b, a, isSameUser);
                      
                      const result = [...onlyInA, ...onlyInB];
    
                      console.log("DIFFRENCE-----------",result)
                      this.setState({AddPaymentsOptions:parseCohortOptions(result)});
                      console.log("AddPaymentsOptions----------",this.state.AddPaymentsOptions)
                    
                  }

    },
    err => {
     // this.props.setLoading(false);
      //toastr.error('ERROR', err);
      //console.log(err);
    }
  ); 



}

  closemodel=()=>{
    this.setState({
      modal:false

  })
  }
  closeDecomissionmodel=()=>{
    this.setState({
      Decomissionmodel:false

  })
  }
/*   componentDidMount() {
 
console.log("componentDidMount run")
}  */
onChangeOfVMCohort = (event, { searchQuery, value }, data) => {
  console.log("cohort id--------->", data);
  const values = String(value).split("-");
  const stateId = values[0];
  console.log("cohort id--------->", values);
  console.log("Cohort id----->:", this.state.cohorts);
  const state = values[1];
  this.setState({
    cohortvalue: value,
    searchCohortQuery: searchQuery,
  });
};

onChangeOfRemoveSlots = (event, { searchQuery, value }, data) => {
  console.log("cohort id--------->", data);
  const values = String(value).split("-");
  const stateId = values[0];
  console.log("remove_slots_id----->", values);
  console.log("remove_slots_id", this.state.cohorts);
  const state = values[1];
  this.setState({
    remove_slots_id: value,
    searchCohortQuery: searchQuery,
  });
};

onChangeOfAddCohorts = (event, { searchQuery, value }, data) => {
  console.log("cohort id--------->", data);
  const values = String(value).split("-");
  const stateId = values[0]; 
  console.log("cohort id----values----->", value);
  
   const state = values[1]; 
  this.setState({
    added_cohort_id: value,
    searchCohortQuery: searchQuery,
  });
  console.log("Cohort id--added_cohort_id--->:", this.state.added_cohort_id);
};


onChangeOfRemovePayments=(event, { searchQuery, value }, data)=>{
  
  console.log("RemovePayments-------->", data);
  const values = String(value).split("-");
  const stateId = values[0]; 
  console.log("RemovePayments----values----->", value);
  
   const state = values[1]; 
  this.setState({
    added_payments_id: value,
    searchCohortQuery: searchQuery,
  });
  console.log(" added_payments_id--->:", this.state.added_payments_id);
}
 
UploadImgBtn=(e)=>{
   
  let formData= new FormData()
  formData.append("file",this.state.image)
  
  console.log("imageform--",formData),
    this.props.UploadImgAPI(
      "/partner/api/v2/s3upload/machine-image",
      "POST",
      formData
      ,
      (response) => {
        console.log("api hiting-------responsive--->", response);
        this.setState({image_path:response.image_path})
      },
      (err) => {
        this.setState({ loading: false });
        toastr.error("Failed", "Failed to add vending machine");
      }
    );
  };

  UploadImgFun=(e)=>{
    console.log("eee--->",e.target.files[0])
    this.setState({image:e.target.files[0]})
  
  }
onChangeOfAddPayments=(event, { searchQuery, value }, data)=>{
  
  console.log("AddPayments------->", data);
  const values = String(value).split("-");
  const stateId = values[0]; 
  console.log("AddPayments---values----->", value);
  
   const state = values[1]; 
  this.setState({
    remove_payments_id: value,
    searchCohortQuery: searchQuery,
  });
  console.log("-remove_payments_id-->:", this.state.remove_payments_id);
}


onChangeOfRemoveCohorts = (event, { searchQuery, value }, data) => {
  console.log("cohort id--------->", data);
  const values = String(value).split("-");
  const stateId = values[0]; 
  console.log("cohort id----values----->", value);
  
   const state = values[1]; 
  this.setState({
    remove_cohort_id:value,
    searchCohortQuery: searchQuery,
  });
  console.log("Cohort id--added_cohort_id--->:", this.state.added_cohort_id);
};
onChangeOfRemoveCohorts = (event, { searchQuery, value }, data) => {
  console.log("remove_cohort_id------->", data);
  const values = String(value).split("-");
  const stateId = values[0]; 
  console.log("remove_cohort_id---values----->", value);
  
   const state = values[1]; 
  this.setState({
    remove_cohort_id:value,
    searchCohortQuery: searchQuery,
  });
  console.log("Cohort id--remove_cohort_id-->:", this.state.remove_cohort_id);
};
onChangeOfVMStreet = (event) => {
  this.setState({ vmStreet: event.target.value });
  console.log('vmStreet------------>',this.state.vmStreet);
};


onChangeOfLat = (event) => {
  this.setState({ lat: event.target.value });
  console.log("lat-------->",this.state.lat)
};
onChangeOfLng = (event) => {
  this.setState({ lng: event.target.value });
  console.log("lng------------->",this.state.lng)
};

onChangeOfVMCity = (event, data) => {
  const values = String(data.value).split('-');
  const city = values[1];
  this.setState({ vmCity: city });
  console.log("city-----------------",this.state.vmCity)
};


onChangeOfVMState = (event, data) => {
  console.log()
  const values = String(data.value).split('-');
  const stateId = values[0];
  const state = values[1];
  console.log("state------------------------------------------------------------------------>",stateId)
  this.props.getCityDataFromAPI(
    `/vendingmachines/location/${stateId}/cities`,
    'GET',
    undefined,
    response => {
      this.setState({
        cityList: parseStateAndCityOptions(response.list),
        cityLoading: false,
        vmState: state,
        loading: false
      });
    },
    err => {
      console.log(err);
      toastr.error('Failed', 'Unable to fetch list of cities');
      this.setState({ loading: false, cityLoading: false });
    }
  );
};






onChangeOfVMTypeId = (event, data) => {
  this.setState({ vmTypeId: data.value });
  console.log("vm type id -->",data.value)
};

onChangeCartLimit = (event, data) => {
  this.setState({ cartLimit: data.value });
  console.log("cartLimit -->",data.value)
};



onChangeOfHardWareTypeId=(e,data)=>{
  this.setState({hardware_type_id:data.value});
  console.log("Hard ware type id -->",this.state.hardware_type_id)

}


onChangeOfIsConsumerAppEnabled = (event, data) => {
  this.setState({ isConsumerAppEnabled: data.value });
  console.log("isConsumerAppEnabled",this.state.isConsumerAppEnabled)
};
onChangeOfIsHealthAppEnabled=(event, data)=>{
  this.setState({ isHealthEnabled: data.value });
  console.log("isHealthEnabled",this.state.isHealthEnabled)
}
onChangeOWarehouse = (event,data) => {
  console.log("MV_ID--", event);
  this.setState({ warehouseId: data.value });
  console.log("MV_ID--", data.value);
  
};


onChangeOparetionalStatus= (event,data) => {
  console.log("operational_status_id--", data.value);
  this.setState({ operational_status_id: data.value });
  console.log("onChangeOparetionalStatus--", data.value);
  
};
  onChangeOfName = (event) => {
   
    this.setState({ vmName: event.target.value });
    console.log("vmName", this.state.vmName);
    
  };
  onChangeOfSerialNo = (event) => {
   
    this.setState({ vmSerialNo: event.target.value });
    console.log("vmName", this.state.vmSerialNo);
    
  };

  onChangeOfSharePercentage = (event, data) => {
    this.setState({ sharePercentage: event.target.value });
    console.log("sharePercentage:------>",this.state.sharePercentage)
  };

  
  onSearchInputChange = (e,data) => {
    
    

    const searchName = e.target.value;
    this.setState({
      searchName,
      
    });
   
  };
  Search=(searchdata)=>{
    
    this.setState({
      searchName:searchdata
    })
    this.props.getvmListAPI(
      `/partner/api/v2/machine/search?value=${searchdata}`,
      'GET',
      undefined,
      response => {
        console.log("Get response ",response);
       let res=response
       console.log("SEARCH RES----->",response)
       this.setState({
        searchList:response
      })
        //this.props.setLoading(false);
      },
      err => {
       // this.props.setLoading(false);
        //toastr.error('ERROR', err);
        //console.log(err);
      }
     
    ); 
    
  }

  onChangeSelectFilterType=(e,data)=>{
    this.setState({
     
      filterType:data.value

    });

    console.log("filterType----",this.state.filterType)

  }


  DecomissionMachine=(vmid)=>{
    this.props.deleteVmApi(
      `/partner/api/v2/machine/${vmid}`,
      'DELETE',
      undefined,
      response => {
        console.log("VM delete1",response);
        toastr.success('SUCCESSFUL', 'DELETED SUCCESSFUL ');
       setTimeout(() => {
        this.OnClickVMSideDetailsPage(vmid)
        console.log('fetchAllMachine()')
        this.setState({
          count: 99,
          start:0
        });
      this.fetchAllMachine()
   
     
      }, 3000);
  
      },
      err => {
       // this.props.setLoading(false);
        toastr.error('ERROR', 'Unable to Delete Vm');
        //console.log(err);
        
      }
     
    )
    
  }
  




  handleUpdateVM = (vmid,inputFields) => {
    console.log('corporateId update',this.state.corporateId?this.state.corporateId:this.state.saveVMDetailsData.corporate.id,this.state.saveVMDetailsData.corporate&&this.state.saveVMDetailsData.corporate.id)

    const payload = {

      name: (this.state.vmName? this.state.vmName : this.state.saveVMDetailsData.name),
      corporate_id:(this.state.corporateId?this.state.corporateId:this.state.saveVMDetailsData.corporate&&this.state.saveVMDetailsData.corporate.id),
      
      hardware_type_id: parseInt(this.state.hardware_type_id),
      machine_type_id: parseInt(this.state.vmTypeId),
      health_report_enabled: this.state.isHealthEnabled,
      consumer_app_enabled:this.state.isConsumerAppEnabled,
      share_percentage: this.state.sharePercentage,
      warehouse_id: this.state.warehouseId,
      added_cohort_ids: this.state.added_cohort_id,
      

     
      removed_cohort_ids:this.state.remove_cohort_id,
      added_payment_config_ids:this.state.remove_payments_id,
      removed_payment_config_ids:this.state.added_payments_id,
      address: {
        street: this.state.vmStreet,
        city: this.state.vmCity,
        state: this.state.vmState,
        latitude: this.state.lat,
        longitude: this.state.lng,
        image_path:this.state.image_path,
        location_type_id:this.state.location_type_id
      },
      serial_number: this.state.vmSerialNo,
      cart_limit:this.state.cartLimit,
      operational_status_id:this.state.operational_status_id,
   
      added_slots:inputFields,
      removed_slot_ids:this.state.remove_slots_id,
    };


    console.log("handleUpdateVM-------------------",vmid)
  
     const msg =this.props.UpdateVMDataFromPartnerAPI(
      `partner/api/v2/machine/${vmid}`,
      "PATCH",
      payload,
   (response) => {
        console.log("api hit");
      },
      (err) => {
        console.log("errorji",err);

      }
    );  

    console.log("Errormsg", msg)

    setTimeout(
      function() {
        
        this.props.getvmListAPI(
          `/partner/api/v2/machine`,
          'GET',
          undefined,
          response => {
            console.log("Get machine ");
            this.setState({
              allMachine: response
            });
        
            //this.props.setLoading(false);
          },
          err => {
           // this.props.setLoading(false);
            //toastr.error('ERROR', err);
            //console.log(err);
          }
        ); 
        this.setState({
          modal: false,
         
        });

        OnClickVMSideDetailsPage=(vmid)
        
      }.bind(this),
      500
    );
    setTimeout(
      function() {
        
        this.props.getvmListAPI(
          `/partner/api/v2/machine`,
          'GET',
          undefined,
          response => {
            console.log("Get machine ");
            this.setState({
              allMachine: response
            });
        
            //this.props.setLoading(false);
          },
          err => {
           // this.props.setLoading(false);
            //toastr.error('ERROR', err);
            //console.log(err);
          }
        ); 
        this.OnClickVMSideDetailsPage=(vmid)
        this.setState({
          modal: false,
         
        });
        
        
      }.bind(this),
      600
    ); 

setTimeout(() => {
 
  console.log("working done1")
  this.fetchAllMachine();
  console.log("working done2")
  //this.OnClickVMSideDetailsPage(50);
  console.log("working done3")

  window.location.reload(false)
}, 3000);

  }

  handleCreateVm = () => {
    return this.props.history.push("/vendingmachines/new");
  };
  
 
  onSearchInputChange = (e, data) => {
    const searchName = data.value;
    this.setState({
      searchName
    });
  };

  onIdSearchChange = (e,data) => {
    const searchId = data.value;

    // to reset the search
    if (data.value === '') {
      return this.setState({
        searchId
      });
    }

    if (!/^\d+$/.test(searchId)) {
      return false;
    }

    this.setState((prev)=>({
      searchId
    }));
  }
  onSearchInputChange = (e) => {
    const searchName = e.target.value;
    console.log("searchName",searchName)
    this.setState({
      searchName
    });
  };

  onChangeCorporates = (event,data) => {
    console.log("MV_ID--", event);
    this.setState({ corporateId: data.value });
    console.log("onChangeCorporates", data.value);
    
  };

  

  render() {
    const vmData = this.props.vms && this.props.vms.vmData && this.props.vms.vmData.list;
   /*  const vmlistData = this.props.vms && this.props.vms.vmlistData && this.props.vms.vmlistData; */
   const vmlistData = this.state.allMachine && this.state.allMachine && this.state.allMachine; 
    const loading = this.props.vms && this.props.vms.loading;
    const {searchName,searchList}= this.state;
   console.log("vmlistData render-------------",this.state.allMachine)



      const filteredVMList =
      !searchName? vmlistData && vmlistData.filter(
        vmlist => {

         
          if(!searchName) 
          
          {
            console.log("LIST------>")
            return true; 
          
          }
         
        }
           
      ):searchList&&searchList.filter(
        vmlist => {

        
          if(searchName){
            console.log("searchList --------------------------------",searchList);
            return searchList
          }
        }
           
      );    
     
    

    return (
      <VendingMachine
        loading={loading}
        

        onSearchChange={this.onSearchInputChange}

        vmlistData={filteredVMList}
        onSearchChnage={this.onSearchInputChange}

        onIdSearchChange={this.onIdSearchChange}
        OnClickVMSideDetailsPage={this.OnClickVMSideDetailsPage}
        vmDetailsData={this.props.vms.vmDetailsData}
        saveVMDetailsData={this.state.saveVMDetailsData}
        onChangeOfName={this.onChangeOfName}
        vmname={this.state.vmName}
        vmSerialNo={this.state.vmSerialNo}
        onChangeOfSerialNo={this.onChangeOfSerialNo}
        vmTypeOptions={this.state.vmTypeOptions}
        hardware_types={this.state.hardware_types}
        warehouses={this.state.warehouses}
        onChangeOfVMTypeId={this.onChangeOfVMTypeId}
        onChangeOfHardWareTypeId={this.onChangeOfHardWareTypeId}
        onChangeOfIsConsumerAppEnabled={this.onChangeOfIsConsumerAppEnabled}
        onChangeOfLat={this.onChangeOfLat}
        lat={this.state.lat}
        lng={this.state.lng}
        onChangeOfLng={this.onChangeOfLng}
        onChangeOfVMCity={this.onChangeOfVMCity}
        cityList={this.state.cityList}
        onChangeOfVMState={this.onChangeOfVMState}
        stateList={this.state.stateList}
        onChangeOfVMStreet={this.onChangeOfVMStreet}
        vmStreet={this.state.vmStreet}
        onChangeOfSharePercentage={this.onChangeOfSharePercentage}
        sharePercentage={this.state.sharePercentage}
        onChangeOWarehouse={this.onChangeOWarehouse}
        oparationalstatusTypes={this.state.oparationalstatusTypes}
        onChangeOparetionalStatus={this.onChangeOparetionalStatus}
        onChangeOfVMCohort={this.onChangeOfVMCohort}
        AddCohortsOptions={this.state.AddCohortsOptions}
        onChangeOfAddCohorts={this.onChangeOfAddCohorts}
        added_cohort_id={this.added_cohort_id}
        removed_cohort_id={this.state.removed_cohort_id}
        RemoveCohortsOptions={this.state.RemoveCohortsOptions}
        onChangeOfRemoveCohorts={this.onChangeOfRemoveCohorts}
        RemovePaymentsOptions={this.state.RemovePaymentsOptions}
        AddPaymentsOptions={this.state.AddPaymentsOptions}
        RemoveSlotsOption={this.state.RemoveSlotsOption}
        handleUpdateVM={this.handleUpdateVM}
        onChangeOfRemovePayments={this.onChangeOfRemovePayments}
        onChangeOfAddPayments={this.onChangeOfAddPayments}
        onChangeOfIsHealthAppEnabled={this.onChangeOfIsHealthAppEnabled}
        onChangeOfRemoveSlots={this.onChangeOfRemoveSlots}
        handleCreateVm={this.handleCreateVm}
        onSearchInputChange={this.onSearchInputChange}
        onChangeSelectFilterType={this.onChangeSelectFilterType}
        UploadImgBtn={this.UploadImgBtn}
        UploadImgFun={this.UploadImgFun}
        fetchNextUsers={this.fetchNextUsers}
        allMachine={this.state.allMachine}
        morescroll={this.state.morescroll}
        modal={this.state.modal}
        openmodel={this.openmodel}
        closemodel={this.closemodel}
        Decomissionmodel={this.state.Decomissionmodel}
        openDecomissionmodel={this.openDecomissionmodel}
        closeDecomissionmodel={this.closeDecomissionmodel}
        Search={this.Search}
        DecomissionMachine={this.DecomissionMachine}
        cityLoading={this.state.cityLoading}
        location_types={this.state.location_types}
        onChangeOfLocationTypeId={this.onChangeOfLocationTypeId}
        cart_Limt={this.state.cart_Limt}
        onChangeCartLimit={this.onChangeCartLimit}

        corporates={this.state.corporates}
        onChangeCorporates={this.onChangeCorporates}


      />
    );
  }
}

function mapStateToProps({ vms })

{
  {console.log("vms------->",vms)}
  return {
    
    
    
    vms
  };
}

export default withRouter(
  connect(mapStateToProps, {
    getDataFromAPI,
    deleteVmApi,
    getvmListAPI,
    getvmDetailsAPI,
    setLoading,
    saveData,
    saveVMListData,
    saveVMDetailsData,
    setActivePage,
    setDropdownLoading,
    setCityOptions,
    setCitySelectedOptions,
    getseedDataFromAPI,
    CreatevmAPI,
    PostcohortsbasicDataFromPartnerAPI,
    UpdateVMDataFromPartnerAPI,
    UploadImgAPI,
    getCityDataFromAPI
  })(VendingMachineContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/VMs/container.jsx